import { render, staticRenderFns } from "./CheckboxesInADropdown.vue?vue&type=template&id=de4c8b84&scoped=true"
import script from "./CheckboxesInADropdown.vue?vue&type=script&lang=js"
export * from "./CheckboxesInADropdown.vue?vue&type=script&lang=js"
import style0 from "./CheckboxesInADropdown.vue?vue&type=style&index=0&id=de4c8b84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4c8b84",
  null
  
)

export default component.exports